// export const avatarAppConfig = {
//   cogSvcRegion: "southeastasia",
//   cogSvcSubKey:
//     "A6gPhDc0LVFktS5QgWSAK0iYWrCjEm3Wuo9slxYbi8JmfkVneNc7JQQJ99ALACqBBLyXJ3w3AAAYACOGxMXb",
//   voiceName: "en-US-AvaMultilingualNeural",
//   avatarCharacter: "Lori",
//   avatarStyle: "graceful",
//   avatarBackgroundColor: "#FFFFFFFF",
//   iceUrl: "turn:relay.communication.microsoft.com:3478",
//   iceUsername:
//     "BQAANp/4LQAB21kn4mYVMUxuLd2m5CpU0wQstWYTVukAAAAQAxBVtNG++9hPVpVUeZeAeeEafc18KFjhodddiIdPujrV6JYAhzg=",
//   iceCredential: "GfG6P93S7Qe8O6t8MsozAnB/Xpc=",
//   openAiAPIKey:
//     "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",
// };


export const avatarAppConfig = {
  cogSvcRegion: "southeastasia",
  cogSvcSubKey:
    "1IiMC3dgY83tkF1MRHtATL3L4UVxbJ5g0MT4dWXX6GZpPO9QbJv0JQQJ99CEACqBBLyXJ3w3AAAYACOGIXoL",
  voiceName: "en-US-AvaMultilingualNeural",
  avatarCharacter: "Lori",
  avatarStyle: "graceful",
  avatarBackgroundColor: "#FFFFFFFF",
  iceUrl: "turn:relay.communication.microsoft.com:3478",
  iceUsername:
    "BQAANnZk6oAB3Oj8ZsaqT5EayWCPyAQdDcn8tGmZnRMAAAAQAxBVtNG++9hPVpVUeZeAeeEaWoSW6eyDuUW31xwog/MFYGiBT0A=",
  iceCredential: "D85mRVqwGHJ/ImB3revoW58KFgk=",
  openAiAPIKey:
    "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",
  sarvamAPIKey: "sk_0k69tgy2_AVfNH0yTxm9HywkCfqd3CHAk", // Active Sarvam AI API Key
};
